var E = /* @__PURE__ */ ((r) => (r[r.NONE = 0] = "NONE", r[r.APPLY = 1] = "APPLY", r[r.CLEAR = 2] = "CLEAR", r))(E || {});
export {
  E as CommitAction
};
